import { GridColDef } from '@mui/x-data-grid';
import tableColumnUtils from '../../../utils/tableColumnUtils';

const buildDynamicColumns = (rows: any[]): GridColDef[] => {
  const uniqueKeys = tableColumnUtils
    .extractUniqueKeys(rows)
    .filter((key) => key !== 'id');
  return tableColumnUtils.createColumnsFromKeys(uniqueKeys);
};

const PER_PAGE = 40;
const ROLLOVER_STATUS_REPORT_FILE_PREFIX = 'Rollover-Status-Report';

export { buildDynamicColumns, PER_PAGE, ROLLOVER_STATUS_REPORT_FILE_PREFIX };
